import { useEffect, useRef } from "react";
import { useNavigate, useNavigationType, useLocation } from "react-router-dom";

export function useReturn() {
  const navigate = useNavigate();

  // Keep track of whether or not a "return" was already issued from the
  // current url, to avoid accidental double-pop of the history stack.
  // Previously we were doing this with a simple "returning" state value,
  // but if the page being returned to had the same type of component on it
  // the component might be updated with new props rather than unmounted
  // and remounted, and thus it would retain the "returning" flag and
  // returns from that page would be blocked.

  // Now we track, in a reference, both the URL of the current page and
  // a "returning" flag saying whether or not a "return" has been initiated.
  // Then, when the URL changes, we clear the returning flag.
  const location = useLocation();
  const url = location.pathname + location.search;
  const returningRef = useRef({ url, returning: false });

  const navigationType = useNavigationType();
  const wasPushed = navigationType === "PUSH";

  useEffect(() => {
    if (returningRef.current.url !== url)
      returningRef.current = { url, returning: false };
  }, [url]);

  return () => {
    if (returningRef.current.returning) {
      console.log(
        "WARNING: return function called twice in one render! " +
          "Aborting subsequent execution to avoid double-pop of " +
          "history state."
      );
    } else {
      navigate(wasPushed ? -1 : "./..");
      returningRef.current.returning = true;
    }
  };
}
